import EventsPage from './EventsPage';
import EventDetailsPage from './EventDetailsPage';
import CreateEventPage from './CreateEventPage';
import EventMapView from './components/EventMapView';

export {
  EventDetailsPage,
  CreateEventPage,
  EventMapView
};

export default EventsPage;